import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Loader2, Sparkles, Wand2, Coins, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

export default function MyAvatars() {
  const navigate = useNavigate();
  const [avatars, setAvatars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const r = await api.get('/avatar-studio/my-avatars'); setAvatars(r.data.avatars); }
      catch { toast.error('Could not load your avatars'); } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="my-avatars-page">
      <div className="max-w-5xl mx-auto px-4 py-6">
        <button onClick={() => navigate('/client/home')} className="flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800 mb-4" data-testid="back-btn">
          <ArrowLeft className="w-4 h-4" /> Dashboard
        </button>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2 mb-1">
          <Sparkles className="w-6 h-6 text-violet-600" /> My AI Avatars
        </h1>
        <p className="text-sm text-slate-500 mb-6">Your purchased avatars. Open the Content Studio to generate new on-brand images — the identity stays locked.</p>

        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-violet-500" /></div>
        ) : !avatars.length ? (
          <Card><CardContent className="p-12 text-center" data-testid="no-avatars">
            <Sparkles className="w-10 h-10 text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500">You don’t have any custom avatars yet.</p>
            <Button className="mt-4" onClick={() => navigate('/client/custom-ambassador')} data-testid="build-avatar-btn">Build your avatar</Button>
          </CardContent></Card>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {avatars.map((a) => (
              <Card key={a.id} className="overflow-hidden hover:shadow-md transition-shadow" data-testid={`avatar-card-${a.id}`}>
                <div className="aspect-square bg-slate-100">
                  {a.avatar_url && <img src={a.avatar_url} alt={a.name} className="w-full h-full object-cover" />}
                </div>
                <CardContent className="p-4">
                  <div className="font-semibold text-slate-900">{a.name}</div>
                  <div className="text-xs text-slate-500 mt-1 flex items-center gap-3">
                    <span>{a.generations} created</span>
                    <span>{a.allowance_remaining}/{a.monthly_allowance} this month</span>
                    <span className="flex items-center gap-0.5"><Coins className="w-3 h-3" /> {a.credits}</span>
                  </div>
                  <Button className="w-full mt-3 bg-violet-600 hover:bg-violet-700" onClick={() => navigate(`/client/avatar-studio/${a.id}`)} data-testid={`open-studio-${a.id}`}>
                    <Wand2 className="w-4 h-4 mr-1" /> Open Content Studio
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
